

export const BiomarkersSection = ({biomarkers}) => {

  const showBiomarker = (key, title, value) => {
    return <div key={key} className="w-100 py-1 mb-1">
          <p className="text-sm fw-semibold mb-0">{title}</p>
          <div className="d-flex align-items-center gap-2">
            <p className="mb-0 lh-sm fw-semibold text-base">{(value !== null && value !== undefined && !Number.isNaN(value)) ? value : '--'}</p>
          </div>
        </div>
  }

  return (
    <div className="d-flex flex-column patient-card-biomarkers-details-width me-3 pe-1">
      <p className="m-0 text-purple">Biomarkers</p>

      <div className="mt-1 d-flex flex-column w-fit">
        { 
          biomarkers?.map(b => showBiomarker(b.id, b.abv,  b.value))
        }
      </div>
    </div>
  );
}
